import { Checkbox, Grid, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { memo, useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { getData, storeData } from "../../utils/GlobalHelper";
import HeaderPage from "../../components/HeaderPage/Index";
import BoxLeftContent from "../../components/BoxLeftContent/BoxLeftContent";
import HeaderRight from "../../components/BoxRightContent/HeaderRight";
import PanelScrollBar from "../../components/BoxRightContent/PanelScrollBar";
import clsx from "clsx";
import GlobalApi from "../../utils/GlobalApi";
import Loading from "../../components/loading/loading";
import ButtonConcent from "../../components/BoxRightContent/ButtonConcent";
import { isEmpty } from "lodash";
import Configs from "../../constants/Configs";

const useStyle = makeStyles({
  font: {
    fontFamily: "DB Heavent",
  },
  content: {
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    color: "var(----text-black)",
  },
});

const TermAndCon = (props) => {
  const classes = useStyle();
  const [lang, setLang] = useState(getData("lang"));
  const [translations, setTranslations] = useState("");
  const [isRead, setIsRead] = useState(false);
  const [checked, setChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [consent, setConsent] = useState({
    checkboxText: "",
    termConText: "",
    titleText: "",
    btnOk: "",
    btnCancel: "",
  });
  const [jumpPage, setJumpPage] = useState(false);
  const checkuserinfo = getData("checkuserinfo");
  const questions = getData("questionsAnswer");

  const checkJumpPage = async () => {
    if (isEmpty(checkuserinfo) || isEmpty(questions)) {
      return true;
    } else {
      return false;
    }
  };
  const oninitData = () => {
    const oldCheck = getData("page_agree");
    if (oldCheck.termandcon === 1) {
      setChecked(true);
      setIsRead(true);
    }
  };
  const callGetConsent = async () => {
    setIsLoading(true);
    try {
      const header = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      await GlobalApi.get(
        Configs.baseURL + "/api/consent?id=termandcon",
        header,
      )
        .then((res) => {
          setIsLoading(false);
          res?.data?.data.forEach((row) => {
            setConsent({
              checkboxText: row?.checkBox,
              termConText: row?.detail,
              titleText: row?.title,
              btnOk: row?.okBtn,
              btnCancel: row?.cancelBtn ? row?.cancelBtn : "",
            });
          });
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
  };
  const handleCheck = (e) => {
    setChecked(e.target.checked);
  };
  // const handleCancel = () => {
  //   setIsModel(true);
  //   let page_agree = {
  //     termandcon: 0,
  //   };
  //   storeData("page_agree", page_agree);
  // };
  const handleNext = (e) => {
    e.preventDefault();
    let page_agree = {
      termandcon: 1,
    };
    storeData("page_agree", page_agree);
    props.history.push("/pdpa");
  };
  const onConfirm = (read) => {
    setIsRead(read);
  };
  useEffect(() => {
    checkJumpPage().then((res) => {
      if (res) {
        setJumpPage(true);
      } else {
        const translation = getData("Translations");
        if (!isEmpty(translation)) {
          callGetConsent();
          setTranslations(translation);
          oninitData();
        } else {
          props.history.push("/");
        }
      }
    });
  }, []);

  return (
    <>
      {jumpPage ? (
        <Grid className="app-splash-screen"></Grid>
      ) : (
        <>
          <HeaderPage
            clickBack={(e) => (e ? props.history.push("/questions") : "")}
            title={translations?.[lang]?.termandcon?.title}
            onChangeLang={(e) => setLang(e)}
          />
          <Loading status={isLoading} />
          <Grid className="background-bg">
            <Grid className="section-consent">
              <Grid className={isMobile ? "box-content-mb" : "box-content"}>
                <Grid container className="box-content-main" columns={16}>
                  {!isMobile && (
                    <Grid item xs={7} className="box-left">
                      <BoxLeftContent
                        translations={translations?.[lang]?.termandcon}
                        clickBack={(e) => props.history.push("/questions")}
                      />
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={isMobile ? 16 : 9}
                    className={isMobile ? "box-right-mb" : "box-right"}
                  >
                    <Grid className="content">
                      <Grid className="content-main">
                        <Grid
                          className="box-right-content pb-3"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            height: isMobile ? "100%" : "100%",
                          }}
                        >
                          <HeaderRight
                            title={translations?.[lang]?.termandcon?.title}
                          />
                          <PanelScrollBar
                            content={
                              <Grid container>
                                <Grid className="sub-title">
                                  <Typography
                                    className="box-title text-left font-20 pt-2"
                                    dangerouslySetInnerHTML={{
                                      __html: consent.titleText,
                                    }}
                                  ></Typography>
                                </Grid>
                                <Grid className={classes.content}>
                                  <Grid
                                    className={clsx(classes.font, "font-20")}
                                    dangerouslySetInnerHTML={{
                                      __html: consent.termConText,
                                    }}
                                  ></Grid>
                                </Grid>
                              </Grid>
                            }
                            confirmRead={onConfirm}
                          />
                          {/* check box content */}
                          <Grid>
                            <Grid className="checkbox-consent">
                              <Checkbox
                                className="check-box-deco"
                                sx={{
                                  color: "#023b66",
                                  opacity: "0.8",
                                  "&.Mui-checked": {
                                    color: "#023b66",
                                    opacity: "0.8",
                                  },
                                }}
                                disabled={!isRead}
                                checked={checked}
                                onChange={handleCheck}
                              />
                              <Grid
                                onClick={(e) => {
                                  if (isRead) {
                                    setChecked(!checked);
                                  } else {
                                    setChecked(false);
                                  }
                                }}
                                className={clsx(
                                  classes.content,
                                  isMobile
                                    ? "content-check-box-mb"
                                    : "content-check-box",
                                  "text-left font-18 product-choice-p",
                                  !isRead ? "checkbox-unread" : "checkbox-read",
                                )}
                                dangerouslySetInnerHTML={{
                                  __html: consent.checkboxText,
                                }}
                              ></Grid>
                            </Grid>
                          </Grid>
                          {/* button */}
                          <ButtonConcent
                            term
                            textOk={consent?.btnOk}
                            textCancel={consent?.btnCancel}
                            isDisbled={!checked}
                            onNextPage={handleNext}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

export default memo(TermAndCon);
